import type { ReactNode } from "react";
import { spacing, type Gap } from "@web/theme/theme";

export type InlineProps = {
  gap?: Gap;
  align?: "start" | "center" | "end" | "baseline" | "stretch";
  justify?: "start" | "center" | "end" | "between";
  wrap?: boolean;
  variant?: "default" | "record-figures";
  className?: string;
  children: ReactNode;
};

const alignClass = { start: "items-start", center: "items-center", end: "items-end", baseline: "items-baseline", stretch: "items-stretch" } as const;
const justifyClass = { start: "justify-start", center: "justify-center", end: "justify-end", between: "justify-between" } as const;

/** Horizontal layout primitive. */
export function Inline({ gap = 2, align = "center", justify = "start", wrap = false, className = "", children, variant = "default" }: InlineProps) {
  return <div className={`flex ${wrap ? "flex-wrap" : ""} ${spacing[gap]} ${alignClass[align]} ${justifyClass[justify]} ${variant === "record-figures" ? "v365-record-figures" : ""} ${className}`.trim()}>{children}</div>;
}
